import './App.css';
import { Button, Col, Container, Form, FormControl, Nav, Navbar, Row } from 'react-bootstrap';
import { Redirect, Route, Switch, useHistory , HashRouter} from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { useState } from 'react';
import queryString from 'query-string';
import About from './About.js';
import Home from './Home.js';
import Projects from './Projects.js';
import Footer from './Footer.js';
import NotFound from './NotFound.js';
function App() {

  return (
        <>
    <Navbar /* bg="light" */ expand="lg" style={{backgroundColor: "#042A2B"}}>
    <LinkContainer to="/" style={{color: "white"}}>
      <Navbar.Brand>Andre Willomitzer</Navbar.Brand>
    </LinkContainer>
    
    
      <Nav className="mr-auto">

    <LinkContainer to="/projects" style={{color: "white"}}>
      <Nav.Link>Projects</Nav.Link>
    </LinkContainer>
    </Nav>
    
    </Navbar>
    <Container>
      <Row>
      <Col>
        <Switch>
          <Route exact path="/" render={()=>(<Redirect to="/Home" />)} />
          {/* <Route exact path="/" render={()=>(<Redirect to="/Home" />)} /> */}
          <Route exact path="/Home" render={()=>(<Home />)}></Route>
          {/* <Route exact path="/About" render={()=>(<About />)}></Route> */}
          <Route exact path="/Projects" render={()=>(<Projects />)}></Route>
          <Route component={NotFound} />
        </Switch>
      </Col>
      </Row>
    </Container>
    <br />
    <Footer></Footer>
    </>
  );
}

export default App;

